import { COMPANY, SERVICES, LOGO } from "@/lib/site";
import { Phone, Mail, Facebook, Instagram, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-navy-deep text-white pt-16 pb-8">
      <div className="px-5 sm:px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="inline-flex items-center bg-white rounded-xl px-3 py-2">
              <img
                src={LOGO.primary}
                alt="Five Peaks Construction LLC"
                className="h-12 w-auto object-contain"
              />
            </div>
            <p className="mt-6 text-white/70 max-w-md leading-relaxed">
              Utah&apos;s full-service construction crew. Residential remodels, commercial build-outs, new
              construction and maintenance — built with care, finished with pride.
            </p>
            <div className="mt-8 flex items-center gap-3">
              <a
                href={COMPANY.facebook}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-facebook"
                aria-label="Facebook"
                className="w-11 h-11 grid place-items-center border border-white/20 rounded-lg hover:bg-sunrise hover:border-sunrise transition-colors"
              >
                <Facebook className="w-4 h-4" />
              </a>
              <a
                href={COMPANY.instagram}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram"
                aria-label="Instagram"
                className="w-11 h-11 grid place-items-center border border-white/20 rounded-lg hover:bg-sunrise hover:border-sunrise transition-colors"
              >
                <Instagram className="w-4 h-4" />
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs uppercase tracking-[0.25em] text-sunrise font-bold">Services</h4>
            <ul className="mt-5 space-y-2.5 text-sm text-white/80">
              {SERVICES.slice(0, 6).map((s) => (
                <li key={s.key}>
                  <a
                    href="#services"
                    className="hover:text-sunrise transition-colors"
                    data-testid={`footer-service-${s.key}`}
                  >
                    {s.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-xs uppercase tracking-[0.25em] text-sunrise font-bold">Contact</h4>
            <ul className="mt-5 space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 text-sunrise mt-0.5" />
                <a href={COMPANY.phoneHref} className="hover:text-sunrise transition-colors" data-testid="footer-phone">
                  {COMPANY.phone}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 text-sunrise mt-0.5" />
                <a
                  href={COMPANY.emailHref}
                  className="hover:text-sunrise transition-colors break-all"
                  data-testid="footer-email"
                >
                  {COMPANY.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-sunrise mt-0.5" />
                <span className="text-white/80">Serving all of Utah</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <div>© {new Date().getFullYear()} Five Peaks Construction LLC. All rights reserved.</div>
          <div>Licensed &amp; Insured · Built in Utah</div>
        </div>
      </div>
    </footer>
  );
}
